export class AddressOptionsLoad {
  public static readonly type = '[AddressOptions]  Load';
  constructor(public payload: string) {}
}

export class AddressOptionsDetailedLoad {
  public static readonly type = '[AddressOptions] Detailed Load';
  constructor(public payload: string) {}
}

export class AddressOptionsInitialState {
  public static readonly type = '[AddressOptions] Set Initial State';
}
